export const reviews = [
  {
    id: 1,
    nl: "Top kapper goede sfeer in de zaak altijd!",
    en: "Top barber, always a great atmosphere in the shop!",
  },
  {
    id: 2,
    nl: "Ik ben ontzettend tevreden met mijn ervaring bij deze kapsalon. Vanaf binnenkomst werd ik vriendelijk ontvangen en goed geholpen. De kapper luisterde echt naar mijn wensen en gaf professioneel advies.",
    en: "I am extremely satisfied with my experience at this barbershop. From the moment I walked in I was welcomed kindly and helped well. The barber really listened to my wishes and gave professional advice.",
  },
  {
    id: 3,
    nl: "Hij luistert goed naar je wensen en levert top werk.",
    en: "He listens carefully to your wishes and delivers top-quality work.",
  },
  {
    id: 4,
    nl: "Mooie sfeer met dito muziek, een kapper die goed luistert en echt heel goed kan knippen met een goed oog voor detail!",
    en: "Great atmosphere with matching music, a barber who listens well and really knows how to cut hair with a great eye for detail!",
  },
  {
    id: 5,
    nl: "Top kapper! Super aardig en goed geknipt. Het was mijn eerste keer hier maar ik ga zeker terugkomen!",
    en: "Top barber! Super friendly and a great haircut. It was my first time here but I will definitely be back!",
  },
];

export const reviewSource = "Google";
